import { SHOULD_ANIMATE } from "../constants"

export const getTransition = (transition: string) => {
  if (SHOULD_ANIMATE) {
    return transition
  } else {
    return "none"
  }
}
